import config from '../helper/config'
import { axiosFunc, AppenData } from '../helper/common'

var token;

export const GetNftCookieToken = () => {
    token = document.cookie.split('; ').reduce((r, v) => {
        const parts = v.split('=')
        return parts[0] === "token" ? decodeURIComponent(parts[1]) : r
    }, '');
}
//Login axios
export const userLogin = async (data) => {
    var senddata = {
        method: 'post',
        url: `${config.USER_BACK_URL}/register`,
        data: data
    }
    let Resp = await axiosFunc(senddata)
    return Resp.data
}
//Register axios
export const userRegister = async (data) => {
    var formdata = AppenData(data)
    var senddata = {
        method: 'post',
        url: `${config.BACK_URL}/nft/nftcreate`,
        data: formdata[0],
        'headers': {
            'Content-Type': 'multipart/form-data',
            'authorization': token
        }

    }

    let Resp = await axiosFunc(senddata)
    return Resp.data
}

// user User IpAddress
export const GetIpAddress = async () => {
    try {
        let response = await fetch(`https://api.ipify.org?format=json`, {
            method: 'GET',
        });
        if (!response.ok) {
            throw new Error(response.statusText || 'Request failed');
        }

        return await response.json();
    }
    catch (err) {

    }
}

export const Subscriberadd = async (data) => {
    var formdata = AppenData(data)
    var senddata = {
        method: 'post',
        url: `${config.USER_BACK_URL}/subscribe`,
        data: data,

    }

    let Resp = await axiosFunc(senddata)
    return Resp.data
}

export const createInstance = async (data) => {
    var senddata = {
        method: 'post',
        url: `${config.CHATURL}/create`,
        data: data,
    }
    let Resp = await axiosFunc(senddata)
    return Resp.data
}

export const sendMsg = async (data) => {
    try {
        let formData = AppenData(data)
        var senddata = {
            method: 'post',
            url: `${config.CHATURL}/sendmsg`,
            data: formData[0],
        }
        let Resp = await axiosFunc(senddata)
        return Resp.data
    }
    catch (err) {
        console.log('sendMsg_err-->', err)
    }
}

export const getMessages = async (data) => {
    try {
        var senddata = {
            method: 'post',
            url: `${config.CHATURL}/getmsg`,
            data: data,
        }
        let Resp = await axiosFunc(senddata)
        return Resp.data
    }
    catch (err) {
        console.log('getMessages_err-->', err)
    }
}

export const sendVerifyotp = async (data) => {
    try {
        var senddata = {
            method: 'post',
            url: `${config.CHATURL}/sendotp`,
            data: data,
        }
        let Resp = await axiosFunc(senddata)
        return Resp.data
    }
    catch (err) {
        console.log('sendVerifyotp_err-->', err)
    }
}

export const clostInstance = async (data) => {
    try {
        var senddata = {
            method: 'post',
            url: `${config.CHATURL}/close`,
            data: data,
        }
        let Resp = await axiosFunc(senddata)
        return Resp.data
    }
    catch (err) {
        console.log('clostInstance_err-->', err)
    }
}

export const GetuserData = async (data) => {
    try {
        let senddata = {
            method: 'post',
            url: config.USER_BACK_URL + '/getuserData',
            data: data,
        }
        let resp = await axiosFunc(senddata);
        return resp.data
    }
    catch (err) {
        console.log('GetuserData_error', err)
    }
}

export const KycSubmit = async (data) => {
    try {

        let formdata = AppenData(data);
        let cookie = ("; " + document.cookie)
            .split(`; ${config.cookiename}=`)
            .pop()
            .split(";")[0];
        let senddata = {
            method: 'post',
            url: config.USER_BACK_URL + '/kycsubmit',
            data: formdata[0],
            headers: {
                'Content-Type': 'multipart/form-data',
                authorization: cookie,
            }
        }
        let resp = await axiosFunc(senddata);
        return resp?.data
    }
    catch (err) {
        console.log('KycSubmit_error', err)
    }
}

export const KYCInputGet = async (data) => {
    try {
        let senddata = {
            method: 'post',
            url: config.USER_BACK_URL + '/getfields',
            data: data,
        }
        let resp = await axiosFunc(senddata);
        return resp?.data
    }
    catch (err) {
        console.log('KYCInputGet_error', err)
    }
}

export const EnableTFA = async (data) => {
    try {
        let senddata = {
            method: 'post',
            url: config.USER_BACK_URL + '/enabletfa',
            data: data,
        }
        let resp = await axiosFunc(senddata);
        return resp?.data
    }
    catch (err) {
        console.log('EnableTFA_error', err)
    }
}

export const SettingsUpdate = async (data) => {
    try {
        let formdata = AppenData(data);
        let senddata = {
            method: 'post',
            url: config.USER_BACK_URL + '/settingsupdate',
            data: formdata[0],
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
        let resp = await axiosFunc(senddata);
        return resp?.data
    }
    catch (err) {
        console.log('SettingsUpdate_error', err)
    }
}

export const ChangeEmailPassword = async (data) => {
    try {
        let senddata = {
            method: 'post',
            url: config.USER_BACK_URL + '/changeemailpassword',
            data: data,
        }
        let resp = await axiosFunc(senddata);
        return resp?.data
    }
    catch (err) {
        console.log('ChangeEmailPassword_error', err)
    }
}

export const SupportTicketAction = async (data) => {
    try {
        let formdata = AppenData(data);
        let senddata = {
            method: 'post',
            url: config.USER_BACK_URL + '/supportticket',
            data: formdata[0],
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
        let resp = await axiosFunc(senddata);
        return resp?.data
    }
    catch (err) {
        console.log('SupportTicketAction_error', err)
    }
}

export const Reactivate = async (data) => {
    try {
        let formdata = AppenData(data);
        let senddata = {
            method: 'post',
            url: config.USER_BACK_URL + '/reactive',
            data: formdata[0],
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
        let resp = await axiosFunc(senddata);
        return resp?.data
    }
    catch (err) {
        console.log('Reactivate_error', err)
    }
}

export const UserNameAction = async (data) => {
    try {
        let formdata = AppenData(data);
        let senddata = {
            method: 'post',
            url: config.USER_BACK_URL + '/username',
            data: formdata[0],
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
        let resp = await axiosFunc(senddata);
        return resp?.data
    }
    catch (err) {
        console.log('UserNameAction_error', err)
    }
}

export const DepositSupportAction = async (data) => {
    try {
        let formdata = AppenData(data);
        let senddata = {
            method: 'post',
            url: config.USER_BACK_URL + '/depositsupport',
            data: formdata[0],
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
        let resp = await axiosFunc(senddata);
        return resp?.data
    }
    catch (err) {
        console.log('DepositSupportAction_error', err)
    }
}

export const WithDrawSupportAction = async (data) => {
    try {
        let formdata = AppenData(data);
        let senddata = {
            method: 'post',
            url: config.USER_BACK_URL + '/withdrawsupport',
            data: formdata[0],
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
        let resp = await axiosFunc(senddata);
        return resp?.data
    }
    catch (err) {
        console.log('WithDrawSupportAction_error', err)
    }
}

export const GetChatSetting = async (data) => {
    try {
        let senddata = {
            method: 'get',
            url: config.USER_BACK_URL + '/getchatsetting',
        }
        let resp = await axiosFunc(senddata);
        return resp?.data
    }
    catch (err) {
        console.log('GetChatSetting_error', err)
    }
}

export const userforget2FA = async (data) => {
    try {
        var senddata = {
            method: 'post',
            url: `${config.USER_BACK_URL}/forget2FA`,
            data: data
        }
        let Resp = await axiosFunc(senddata)
        return Resp.data
    } catch (error) {
        console.log('userforget2FA_error', error)
    }
}

